// extracted by mini-css-extract-plugin
export default {"gridItem":"VLoz8DX---styles_gridItem__uvMMX"};